function randomBytes(): Uint8Array {
  const bytes = new Uint8Array(16)
  const cryptoApi = globalThis.crypto

  if (typeof cryptoApi?.getRandomValues === 'function') {
    try {
      return cryptoApi.getRandomValues(bytes)
    } catch {
      // Fall through to a non-cryptographic source. This value is an
      // idempotency identifier, not a security credential.
    }
  }

  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256)
  }

  return bytes
}

export function createIdempotencyKey(): string {
  const cryptoApi = globalThis.crypto

  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID()
  }

  const bytes = randomBytes()
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const value = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')

  return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`
}
